import apiClient from './apiClient';
import { cachedGet } from './sessionConfigCache';

// ==================== Stripe Payments API ====================

export const paymentsAPI = {
  // Get available packages
  getPackages: async () => cachedGet('payments/packages', async () => {
    const response = await apiClient.get('/payments/packages');
    return response.data;
  }),

  // Get payment fee settings (session-static config)
  getFeeSettings: async () => cachedGet('payments/fee-settings', async () => {
    const response = await apiClient.get('/payments/fee-settings');
    return response.data;
  }),

  // Create checkout session
  createCheckout: async (packageId, vendorId = null) => {
    const originUrl = window.location.origin;
    const response = await apiClient.post('/payments/create-checkout', {
      packageId,
      originUrl,
      vendorId
    });
    return response.data;
  },

  // Get payment status
  getStatus: async (sessionId) => {
    const response = await apiClient.get(`/payments/status/${sessionId}`);
    return response.data;
  },

  // Get payment history
  getHistory: async () => {
    const response = await apiClient.get('/payments/history');
    return response.data;
  },
};


// ==================== Billing API ====================

export const billingAPI = {
  // Get invoices with time range filter
  getInvoices: async (timeRange = '6months') => {
    const response = await apiClient.get(`/billing/invoices?time_range=${timeRange}`);
    return response.data;
  },

  // Get subscription status
  getSubscription: async () => cachedGet('billing/subscription', async () => {
    const response = await apiClient.get('/billing/subscription');
    return response.data;
  }),

  // Get billing summary
  getSummary: async () => {
    const response = await apiClient.get('/billing/summary');
    return response.data;
  },

  // Export data (returns blob for download)
  exportData: async (exportType, format = 'csv', timeRange = 'all') => {
    const response = await apiClient.get(
      `/billing/export/${exportType}?format=${format}&time_range=${timeRange}`,
      { responseType: 'blob' }
    );
    return response;
  },

  // Download invoice
  downloadInvoice: async (invoiceId) => {
    const response = await apiClient.get(`/billing/invoices/${invoiceId}`);
    return response.data;
  }
};
